module.exports = __webpack_public_path__ + "static/media/GoldText.cfb74bd2.png";